export default __webpack_public_path__ + "static/media/hotel-resort-img-16.57d9653c.jpg";